<template lang="html">
  <div class="snack-message">
    <button @click="close" class="snack-message-close btn">
      <i class="fa fa-times font-weight-normal text-muted"></i>
    </button>
    <div class="snack-message-title font-weight-bold" :class="themeTextColor">
      <i class="fa fa-exclamation-circle" :class="themeTextColor"></i>
      {{ title }}
    </div>
    <hr class="my-1" >
    <div class="snack-message-text font-weight-normal">
      {{ text }}
    </div>
    <div v-if="linkText" class="text-center">
      <a href="#" @click.prevent="linkAction">{{linkText}}</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

const component = {
  props: {
    timeout: { type: Number, default: 5000 },
    title: { type: String, default: 'ATENCIÓN' },
    text: { type: String, default: 'Mensaje emergente.' },
    linkAction: { type: Function, default: () => {} },
    linkText: { type: String, default: '' },
    noMount: { type: Boolean, default: false },
    theme: { type: String, default: "success" }
  },

  methods: {
    close () {
      this.$el.classList.add('closing')

      setTimeout(() => {
        this.$el.remove()
        this.$destroy()
      }, 500)
    }
  },

  computed: {

    themeTextColor () {
      switch (this.theme) {
        case "warning":
          return "text-warning";
        case "error":
          return "text-danger";
        case "success":
        default:
          return "text-success";
      }
    }
  },

  created () {
    if (!this.noMount) {
      const cont = document.createElement('div')
      document.getElementById('dialogs').append(cont)
      this.$mount(cont)
    }
  },

  mounted () {
    this.$el.classList.add('show')

    if (this.timeout > 0)
      setTimeout(this.close, this.timeout)
  }
}

export default component

const ComponentClass = Vue.extend(component)

export const instance = props => new ComponentClass({ propsData: props })
</script>

<style lang="scss">
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  .snack-message {
    position: relative;
    // visibility: hidden;
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 0.5rem;
    position: fixed;
    z-index: 2;
    left: 0;
    bottom: 0;
    font-size: 1rem;
    border: solid 1px $gray-200;

    &.show {
      // visibility: visible;
      -webkit-animation: fadein 0.5s;
      animation: fadein 0.5s;
    }

    &.closing {
      -webkit-animation: fadeout 0.5s;
      animation: fadeout 0.5s;
    }

    &-close {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0.5rem 0.25rem;
    }

    &-title {
      padding-right: 1rem;
    }

    &-text {
      padding: 0.5rem 2rem;
    }

    @-webkit-keyframes fadein {
      from {bottom: -30px; opacity: 0;}
      to {bottom: 0; opacity: 1;}
    }

    @keyframes fadein {
      from {bottom: -30px; opacity: 0;}
      to {bottom: 0; opacity: 1;}
    }

    @-webkit-keyframes fadeout {
      from {bottom: 0; opacity: 1;}
      to {bottom: -30px; opacity: 0;}
    }

    @keyframes fadeout {
      from {bottom: 0; opacity: 1;}
      to {bottom: -30px; opacity: 0;}
    }
  }

  @media screen and (min-width: map-get($grid-breakpoints, "sm")) {
    .snack-message {
      width: 300px;
      left: auto;
      right: 2%;
      min-height: 120px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/SnackMessage.vue